import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  BillLineCandidate, FixedAssetFromBillLineRequest, FixedAssetValueEvent, FixedAssetValueSummary,
  ImpairmentRequest, ImpairmentReversalRequest, ReserveTransferRequest, RevaluationRequest,
} from '../interfaces/fixedAsset/fixedAssetValue.interface';
import { FixedAsset } from '../interfaces/fixedAsset/fixedAsset.interface';

const E = ENDPOINTS.FIXED_ASSET_VALUE;

export const FixedAssetValueService = {
  summary: async (assetId: string): Promise<FixedAssetValueSummary> => (await axios.get(E.SUMMARY(assetId))).data,
  revalue: async (assetId: string, dto: RevaluationRequest): Promise<FixedAssetValueEvent> =>
    (await axios.post(E.REVALUE(assetId), dto)).data,
  impair: async (assetId: string, dto: ImpairmentRequest): Promise<FixedAssetValueEvent> =>
    (await axios.post(E.IMPAIR(assetId), dto)).data,
  reverseImpairment: async (assetId: string, dto: ImpairmentReversalRequest): Promise<FixedAssetValueEvent> =>
    (await axios.post(E.IMPAIRMENT_REVERSAL(assetId), dto)).data,
  transferReserve: async (assetId: string, dto: ReserveTransferRequest): Promise<FixedAssetValueEvent> =>
    (await axios.post(E.RESERVE_TRANSFER(assetId), dto)).data,
  reverseEvent: async (assetId: string, eventId: string): Promise<FixedAssetValueEvent> =>
    (await axios.post(E.REVERSE_EVENT(assetId, eventId))).data,
  billLines: async (billId: string): Promise<BillLineCandidate[]> => (await axios.get(E.BILL_LINES(billId))).data,
  fromBillLine: async (dto: FixedAssetFromBillLineRequest): Promise<FixedAsset> =>
    (await axios.post(E.FROM_BILL_LINE, dto)).data,
};
